import logger from 'utils/logger';

const RETRY_TIMEOUT = 1500;
const MAX_NUMBER_OF_RETRIES = 3;

const flattenTOC = (tocList) => {
  let result = [];

  for (const item of tocList) {
    result.push({
      title: item.Title,
      href: item.Href,
    });

    if (item.Children && item.Children.length > 0) {
      result = result.concat(flattenTOC(item.Children));
    }
  }

  return result;
}

const getTOCItems = (readerRef) => {
  return flattenTOC(readerRef.current.navigator.publication.TOC);
}

const getAnnotationItems = (readerRef) => readerRef.current.annotations;

export const loadNavItems = async (params) => {
  const { readerRef, callback, logName, retry = 0 } = params;

  try {
    const items = await callback(readerRef);

    logger.log(logName, `Items were successfully loaded`, items);

    return items;
  } catch (error) {
    if (retry <= MAX_NUMBER_OF_RETRIES) {
      logger.log(logName, `Retrying to load items. Attempt: ${retry}.`, error);

      return new Promise((resolve) => {
        setTimeout(async () => {
          const retryItems = await loadNavItems({ ...params, retry: retry + 1 });

          resolve(retryItems);
        }, RETRY_TIMEOUT);
      });
    }
    logger.log(logName, `Failed to load items. Attempted ${retry} times.`, error);

    return [];
  }
};

export const loadTOCItems = async (readerRef) =>
  loadNavItems({ readerRef, callback: getTOCItems, logName: 'getTOCItems' });

export const loadAnnotationItems = async (readerRef) =>
  loadNavItems({ readerRef, callback: getAnnotationItems, logName: 'getAnnotationItems' });


export const locationToAnnotation = (item) => ({
  id: item?.id,
  page: item?.locations?.position,
  title: item?.title,
  highlight: item?.text?.highlight,
  note: item?.highlight?.note,
  date: item?.created,
  color: item?.highlight?.color,
  selector: item,
});

export const locationToChapter = (item) => ({
  id: item?.id,
  page: item?.locations?.position,
  title: item?.title,
  selector: item,
});
